import React from 'react';
import TableData from './components/tableData';
const index = () => {
  return (
    <div>
      <TableData />
    </div>
  );
};

export default index;
